import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import {
  setLoadingState,
  queryEligibilitySuccess,
  queryEligibilityError,
  addPageData,
  navigateWizard,
} from '../actions';
import EligibilityAPI from '../api/EligibilityAPI';
import buildEligibilityRequest from '../api/EligibilityAPIRequest';
import { QUERY_ELIGIBILITY_REQUEST } from '../constants/actionTypes';
import * as payloadFactory from '../lib/pageDataPayloadFactory';
import {
  buildServerSelector,
  residenceHistorySelector,
  campusSelector,
  accessTokenSelector,
} from '../reducers/selectors';

import { applicationUpdateWorker } from './applicationUpdate';
import { manageAPIError } from './helpers/errorHelper';

function* eligibilityWatcher() {
  yield takeLatest(QUERY_ELIGIBILITY_REQUEST, eligibilityWorker);
}

function* eligibilityWorker(action) {
  try {
    const accessToken = yield select(accessTokenSelector);
    const buildServer = yield select(buildServerSelector);
    const residenceHistory = yield select(residenceHistorySelector);
    const campus = yield select(campusSelector);
    yield put(setLoadingState(true));
    yield call(applicationUpdateWorker, action);
    const payload = yield call(buildEligibilityRequest, buildServer, residenceHistory, campus);
    const response = yield call(EligibilityAPI.queryEligibility, payload, accessToken);
    yield put(queryEligibilitySuccess(response));
    yield put(setLoadingState(false));

    const { eligibility_id: eligibilityId, status } = response;
    const eligibilityIdPayload = yield call(
      payloadFactory.createAddPageDataPayload,
      'eligibilityId',
      eligibilityId,
    );
    yield put(addPageData(eligibilityIdPayload));

    const eligibilityStatusPayload = yield call(
      payloadFactory.createAddPageDataPayload,
      'eligibilityStatus',
      status,
    );
    yield put(addPageData(eligibilityStatusPayload));

    yield put(navigateWizard({ dir: 'fwd' }));
  } catch (error) {
    yield put(queryEligibilityError());
    const clearEligibilityIdPayload = yield call(
      payloadFactory.createResetPageDataPayload,
      'eligibilityId',
    );
    yield put(addPageData(clearEligibilityIdPayload));

    const clearEligibilityStatusPayload = yield call(
      payloadFactory.createResetPageDataPayload,
      'eligibilityStatus',
    );
    yield put(addPageData(clearEligibilityStatusPayload));

    yield fork(manageAPIError, { ...error, action });
    yield put(setLoadingState(false));
  }
}

export { eligibilityWorker };
export default eligibilityWatcher;
